
import { Users, BarChart, Crown, CreditCard } from "lucide-react";

export const ComingSoonSection = () => {
  const features = [
    {
      icon: Users,
      title: "Promoter Affiliate System",
      description: "Earn commissions by selling other promoters' events",
      progress: 80
    },
    {
      icon: BarChart,
      title: "Crowd Flow Insights",
      description: "Track where guests spend the most time inside events",
      progress: 65
    },
    {
      icon: Crown,
      title: "Customizable VIP Upgrades",
      description: "Sell premium table service or backstage access",
      progress: 45
    },
    {
      icon: CreditCard,
      title: "On-Site Sales Integration",
      description: "Sell tickets at the door with tap-and-go payments",
      progress: 30
    }
  ];

  return (
    <div className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-16">
          Coming Soon
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="p-6 rounded-xl bg-gray-900 border-2 border-purple-500/30 shadow-[0_0_30px_rgba(168,85,247,0.15)]"
            >
              <div className="flex items-center gap-4 mb-4">
                <feature.icon className="w-12 h-12 text-purple-400" />
                <span className="px-3 py-1 text-xs font-semibold bg-purple-500/20 text-purple-300 rounded-full border border-purple-500/30">
                  Coming Q2 2024
                </span>
              </div>
              <h3 className="text-xl font-semibold text-white mb-2">{feature.title}</h3>
              <p className="text-gray-400 mb-4">{feature.description}</p>
              <div className="w-full bg-gray-800 rounded-full h-2">
                <div
                  className="bg-gradient-to-r from-purple-600 to-pink-600 h-2 rounded-full"
                  style={{ width: `${feature.progress}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
